import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    // translate: 'MENU.HOME',
    type: 'item',
    icon: 'home',
    externalUrl: true,
    url: 'dashboard'
  },
  {
    id: 'profile',
    title: 'Profile',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'user',
    url: 'profile'
  },
  {
    id: 'fundwallet',
    title: 'Fund Wallet',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'bookmark',
    externalUrl: true,
    url: 'fundwallet'
  },
  {
    id: 'buydata',
    externalUrl: true,
    title: 'Buy Databundle',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'wifi',
    url: 'buydata'
  },
  {
    id: 'buyairtime',
    externalUrl: true,
    title: 'Buy Airtime',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'phone',
    url: 'buyairtime'
  },
  {
    id: 'cabletv',
    title: 'Cable TV',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'tv',
    externalUrl: true,
    url: 'cabletv'
  },
  {
    id: 'power',
    title: 'Electricity',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'star',
    externalUrl: true,
    url: 'electricity'
  },
  {
    id: 'datacard',
    title: 'Data Card',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'credit-card',
    externalUrl: true,
    url: 'datacard'
  },
  {
    id: 'recharge-card',
    title: 'Recharge Card',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'smartphone',
    externalUrl: true,
    url: 'voucher'
  },
  {
    id: 'education-pins',
    title: 'Education Pins',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'book',
    externalUrl: true,
    url: 'education'
  },
  {
    id: 'transaction-history',
    title: 'Transactions',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'list',
    externalUrl: true,
    url: 'transaction-history'
  },
  {
    id: 'change-pin',
    title: 'Change Pin',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'lock',
    externalUrl: true,
    url: 'change-pin'
  },
  {
    id: 'more-links',
    title: 'More Pages',
    // translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'chevrons-right',
    externalUrl: true,
    url: 'all-pages'
  },
]
